<template>
    <div class="menu_box">
        <div class="menu_banner">> {{departmentName}}</div>
        <ul class="menu_ul">
            <li><router-link :to="this.departmentPath+'/index.aspx'">· 简介</router-link></li>
            <!--<li><router-link :to="this.departmentPath+'/zxdt.aspx'">· 最新动态</router-link></li>-->
            <li><router-link :to="this.departmentPath+'/xsjz.aspx'">· 学术讲座</router-link></li>
            <!--<li><a href="https://www.fdsm.fudan.edu.cn/AboutUs/minglu.aspx" target="_blank">· 师资简介</a></li>
            <li><router-link :to="this.departmentPath+'/zhuanye.aspx'">· 专业介绍</router-link></li>
            <li><a href="https://www.fdsm.fudan.edu.cn/Graduate/Enrollment.aspx" target="_blank">· 招生信息</a></li>
            <li><router-link :to="this.departmentPath+'/luntan.aspx'">· 学术论坛</router-link></li>-->
            <li><router-link :to="this.departmentPath+'/yjzx.aspx'">· 研究中心</router-link></li>
            <!--<li><router-link :to="this.departmentPath+'/xglj.aspx'">· 相关链接</router-link></li>
            <li><router-link :to="this.departmentPath+'/lxwm.aspx'">· 联系我们</router-link></li>-->
        </ul>
    </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    departmentName: function () {
      return this.$store.state.CurrDepartName
    },
    departmentPath: function () {
      return this.$store.state.CurrDepartPath
    }
  },
  watch: {
  }
}
</script>
